import * as Yup from "yup";

export const focusAreaSchema = Yup.object().shape({
  name: Yup.string().required("Name field cannot be empty"),
});
